import http from "../http-common";

class SubmitService {

  getSubmit(accessKey) {
    return http.get("/submit/"+accessKey);
  }
  saveResposta(accessKey,idPregunta,valor){
    let data = {};
    data.idPregunta = idPregunta;
    data.valor = valor;
    return http.post("/submit/"+accessKey+"/resposta",data);    
  }
  calcularUltimaPregunta(accessKey,idPregunta,valor){
    let data = {};
    data.idPregunta = idPregunta;
    data.valor = valor;
    return http.post("/submit/"+accessKey+"/resposta/calcularUltimaPregunta",data);    
  }
  respostaAnterior(accessKey){
    let data = {};
    return http.post("/submit/"+accessKey+"/resposta/anterior",data);    
  }

}

export default new SubmitService();